import { getCatalogFieldFacetsUrl } from 'api/CatalogAPI';
import { useRestQuery } from 'utils/hooks/api';

import {
  UseCatalogFieldFacetsHookInputs,
  UseCatalogFieldFacetsQueryData,
  UseFieldFacetsHookOutput,
} from './types';
import { useMemoizedFacets } from './useMemoizedFacets';

export const useCatalogFieldFacets = ({
  catalogName,
  field,
  enabled,
}: UseCatalogFieldFacetsHookInputs): UseFieldFacetsHookOutput => {
  const {
    data: { catalogFieldValues = [] } = {},
    isError: didError,
    isLoading,
  } = useRestQuery<UseCatalogFieldFacetsQueryData>(
    getCatalogFieldFacetsUrl(catalogName, field),
    {},
    {
      enabled,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
    },
  );
  const fieldFacets = useMemoizedFacets(catalogFieldValues);
  return { fieldFacets, didError, isLoading };
};
